import { render, staticRenderFns } from "./VenueLabelForm.vue?vue&type=template&id=4e64477e"
import script from "./VenueLabelForm.vue?vue&type=script&lang=ts"
export * from "./VenueLabelForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports